import React from 'react';
import UserStore from '../stores/UserStore';
import UserConstants from '../constants/UserConstants';
import UserActions from '../actions/UserActions';
import ChangeUserPassword from './ChangeUserPassword';
import * as Inovx from '@shared';
var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;

var InovxControls = Inovx.Shared.Controls;

declare var InovxLoader: any;

interface UserFormProps {
}

interface UserSettingsState {
    isActionInProgress?: boolean;
    actionInProgressMsg?: string;
    validation?: IValidationDictionaryObject;
    settings?: IUserAppSetting;
    displayPasswordChange?: boolean;
    currentUserHasPassword: boolean;
    currentUser?: IUserDetails;
}

function getActionInProgress(): boolean {
    return SystemStore.isActionInProgress(UserConstants.SETTINGS_SAVE);
}

var _actionInProgressMsg: string;
function getFormState(): UserSettingsState {
    return {
        isActionInProgress: getActionInProgress(),
        actionInProgressMsg: _actionInProgressMsg,
        validation: UserStore.getValidation(UserConstants.USER_SETTINGS_FORM),
        settings: UserStore.getEditSettings(),
        displayPasswordChange: false,
        currentUserHasPassword: false,
        currentUser: UserStore.getCurrentUser()
    };
}

class UserSettings extends React.Component<UserFormProps, UserSettingsState> {

    private _passwordComplexityChanged = false;
    private _displayPasswordChange = false;

    constructor(props: UserFormProps) {
        super(props);
        this.state = getFormState();
    }

    private _onChange = (event: any) => {
        UserActions.editCurrentObject(UserConstants.USER_SETTINGS_FORM, event.target.name, event.target.value);
    }

    private _onPasswordComplexityChange = (event: any) => {
        this._passwordComplexityChanged = true;
        UserActions.editCurrentObject(UserConstants.USER_SETTINGS_FORM, event.target.name, event.target.value);
    }

    private _onCheckChange = (event: any) => {
        UserActions.editCurrentObject(UserConstants.USER_SETTINGS_FORM, event.target.name, event.target.value === "true");

    }

    private _loadState = () => {
        this.setState(getFormState());
    }

    private _systemChange = () => {
        this.setState({
            isActionInProgress: getActionInProgress()
        });
    }

    private _saveChangePassword = () => {
        this.setState({
            displayPasswordChange: false
        });
        this._save();
    }

    private _cancelChangePassword = () => {
        this.setState({
            displayPasswordChange: false
        });
    }

    private _saveSettings = () => {
        UserActions.saveSettings((error: IServiceErrorObject) => {
            this.setState({
                displayPasswordChange: true,
            })
        }, true);
        this.setState({ actionInProgressMsg: InovxLoader.t('users:form.saving') });
    }

    private _save = () => {
        var that = this;
        if (UserStore.getIsValidObject(UserConstants.USER_SETTINGS_FORM)) {
           if (that._passwordComplexityChanged) {
                SystemActions.displayYesNoMessage({
                    confirmCallback: () => {
                        UserActions.resetPasswords();
                        that._saveSettings();
                    },
                    cancelCallback: () => {
                        that._saveSettings();
                    },
                    message: InovxLoader.t('users:settingsForm.resetPasswords')
                } as IMessageConfirmObject);
                that._passwordComplexityChanged = false;
            }
           else {
               that._saveSettings();
            }

        } else {
            this.setState({} as any);
        }
    }

    private _cancel = () => {
        UserActions.hideSettings();
    }

    private _isEmptyOrNull = (value: string) => {
        return !value || value.length <= 0;
    }

    private _checkForUnsavedChanges = (event: any) => {
        if (UserStore.getHasChanges()) {
            event.returnValue = InovxLoader.t('common:msgBox.browserSaveChanges');
        }
    }



    componentDidMount() {
        UserStore.addChangeListener(this._loadState);
        SystemStore.addChangeListener(this._systemChange);
        window.addEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this._loadState);
        SystemStore.removeChangeListener(this._systemChange);
        window.removeEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    render() {
        var inputObj = {
            className: 'form-control',
            type: 'text'
        }

        var settings = this.state.settings;

        var passwordMinCharacters = {
            ...inputObj,
            name: 'PasswordCharacters',
            value: settings.PasswordCharacters.toString()
        };

        var requiredSymbols = {
            ...inputObj,
            name: 'PasswordSymbols',
            value: settings.PasswordSymbols.toString()
        };

        var requireNumbers = {
            ...inputObj,
            name: 'PasswordNumbers',
            value: settings.PasswordNumbers.toString()
        };

        var passwordExpiration = {
            ...inputObj,
            name: 'PasswordExpiration',
            value: settings.PasswordExpiration.toString()
        };

        var failedAttempts = {
            ...inputObj,
            name: 'AllowedAttempts',
            value: settings.AllowedAttempts.toString()
        };

        return (
            <InovxControls.StaticHeaderForm title={InovxLoader.t('users:settingsForm.headerTitle')} saveOnClick={this._save} cancelOnClick={this._cancel}
                isActionInProgress={this.state.isActionInProgress} inProgressMessage={this.state.actionInProgressMsg} >

                <div className='user-form'>
                    { true ? null :
                        <InovxControls.GroupBox title={InovxLoader.t('users:settingsForm.rememberMe')} class="gb-remember-me">
                            <div className="form-field">
                                <div className="fr-margin">
                                    <label className="radio-inline">
                                        <input type="radio" value="true" name="RememberMe" onChange={this._onCheckChange} checked={settings.RememberMe} />
                                        {InovxLoader.t("users:settingsForm.enabled")}
                                    </label>
                                    <label className="radio-inline">
                                        <input type="radio" value="false" name="RememberMe" onChange={this._onCheckChange} checked={!settings.RememberMe} />
                                        {InovxLoader.t("users:settingsForm.disabled")}
                                    </label>
                                </div>
                            </div>
                        </InovxControls.GroupBox>
                    }

                    <InovxControls.GroupBox title={InovxLoader.t('users:settingsForm.passwordSettings')} class="gb-password-settings">
                        <div className="form-field">
                            <div className="fr-margin">
                                <label className="radio-inline">
                                    <input type="radio" value="false" name="PasswordExpires" onChange={this._onCheckChange} checked={!settings.PasswordExpires} />
                                    {InovxLoader.t("users:settingsForm.passwordNotExpires")}
                                </label>
                                <label className="radio-inline">
                                    <input type="radio" value="true" name="PasswordExpires" onChange={this._onCheckChange} checked={settings.PasswordExpires} />
                                    {InovxLoader.t("users:settingsForm.passwordExpires")}
                                </label>
                            </div>
                        </div>

                        <InovxControls.FormField title={InovxLoader.t("users:settingsForm.passwordExpiration")} tooltip={InovxLoader.t("users:settingsForm.passwordExpirationToolTip")} inputName='PasswordExpiration'>
                            <InovxControls.ValidationInput {...passwordExpiration} className="form-control" onChange={this._onChange} validation={this.state.validation['PasswordExpiration']} readOnly={!settings.PasswordExpires} />
                        </InovxControls.FormField>

                        <InovxControls.FormField title={InovxLoader.t("users:settingsForm.failedAttempts")} tooltip={InovxLoader.t("users:settingsForm.failedAttemptsToolTip")} inputName='AllowedAttempts'>
                            <InovxControls.ValidationInput {...failedAttempts} className="form-control" onChange={this._onChange} validation={this.state.validation['AllowedAttempts']} />
                        </InovxControls.FormField>
                    </InovxControls.GroupBox>

                    <InovxControls.GroupBox title={InovxLoader.t('users:settingsForm.passwordComplexityTitle')} class="gb-password-complexity">

                        <InovxControls.FormField title={InovxLoader.t("users:settingsForm.passwordMinCharacters")} tooltip={InovxLoader.t("users:settingsForm.passwordMinCharactersToolTip")} inputName='MinCharacters'>
                            <InovxControls.ValidationInput {...passwordMinCharacters} className="form-control" onChange={this._onPasswordComplexityChange} validation={this.state.validation['PasswordCharacters']} />
                        </InovxControls.FormField>

                        <InovxControls.FormField title={InovxLoader.t("users:settingsForm.requiredSymbols")} tooltip={InovxLoader.t("users:settingsForm.requiredSymbolsToolTip")} inputName='RequiredSymbols'>
                            <InovxControls.ValidationInput {...requiredSymbols} className="form-control" onChange={this._onPasswordComplexityChange} validation={this.state.validation['PasswordSymbols']} />
                        </InovxControls.FormField>

                        <InovxControls.FormField title={InovxLoader.t("users:settingsForm.requireNumbers")} tooltip={InovxLoader.t("users:settingsForm.requireNumbersToolTip")} inputName='UserName'>
                            <InovxControls.ValidationInput {...requireNumbers} className="form-control" onChange={this._onPasswordComplexityChange} validation={this.state.validation['PasswordNumbers']} />
                        </InovxControls.FormField>

                    </InovxControls.GroupBox>

                    <InovxControls.ModalPopUp isOpen={this.state.displayPasswordChange} >
                        <ChangeUserPassword User={this.state.currentUser} onPasswordChanged={this._saveChangePassword} onCancel={this._cancelChangePassword} message={InovxLoader.t('users:settingsForm.setPasswordInfo')} />
                    </InovxControls.ModalPopUp>

                </div>
            </InovxControls.StaticHeaderForm>
        );
    }
}

export default UserSettings;
